import { AloSecurityItem } from '@/models/alo/AloSecurityItem'
import { getDefaultSecurityRights } from '@/enum/SecurityItems'
import { AloIdentity, getDefaultAloIdentity } from '@/models/alo/AloIdentity'
import { AloUser, getDefaultAloUser } from '@/models/alo/AloUser'

export interface IAuthState {  
  authStatus: string
  userStatus: string
  user: AloUser
  renewTokenId: number
  userSecurity: { [index: string]: AloSecurityItem}
  redirectPath: string
}

//Initial State
const state: IAuthState = {  
  authStatus: '',
  userStatus: '',
  user: getDefaultAloUser(),
  renewTokenId: 0,
  userSecurity: getDefaultSecurityRights(),
  redirectPath: '/'
}
export default state